import {
    collection,
    doc,
    type FirestoreDataConverter,
    getDoc,
    QueryDocumentSnapshot,
    type SnapshotOptions,
} from "firebase/firestore";
import { Timestamp } from "firebase/firestore";

import { db } from "@/lib/firebase/client.ts";
import type { DataSubmission } from "@/models/data-submission.ts";
import { DatabaseRepository } from "@/repositories/database-repository.ts";

const dataSubmissionConverter: FirestoreDataConverter<DataSubmission> = {
    toFirestore(session: DataSubmission) {
        return { ...session };
    },
    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): DataSubmission {
        const data = snapshot.data(options)!;
        return {
            uid: snapshot.id, // always safe
            ...data,
            idNumberValidityEndDate: (data.idNumberValidityEndDate as Timestamp)?.toDate(),
            pensionStartDate: (data.pensionStartDate as Timestamp)?.toDate(),
            birthDate: (data.birthDate as Timestamp)?.toDate(),
            createdAt: (data.createdAt as Timestamp)?.toDate(),
            updatedAt: (data.updatedAt as Timestamp)?.toDate(),
        } as DataSubmission;
    },
};

export class DataSubmissionRepository extends DatabaseRepository<DataSubmission> {
    private static instance: DataSubmissionRepository;
    protected readonly collection = collection(db, "dataSubmissions").withConverter(dataSubmissionConverter);

    private constructor() {
        super();
    }

    public static getInstance(): DataSubmissionRepository {
        if (!DataSubmissionRepository.instance) {
            DataSubmissionRepository.instance = new DataSubmissionRepository();
        }
        return DataSubmissionRepository.instance;
    }

    async getById(uid: string): Promise<DataSubmission | null> {
        const ref = doc(this.collection, uid);
        const snap = await getDoc(ref);
        if (!snap.exists()) return null;
        return snap.data() satisfies DataSubmission;
    }
}
